// Desktop menu
document.addEventListener("DOMContentLoaded", function () {
  let lastFocusedMenuTrigger = null;

  const menuItems = document.querySelectorAll(
    ".site-nav #AccessibleNav .site-nav--has-dropdown",
  );

  function getDropdown(item) {
    const dropdown = item.nextElementSibling;
    return dropdown && dropdown.classList.contains("site-nav__dropdown")
      ? dropdown
      : null;
  }

  menuItems.forEach((item) => {
    item.addEventListener("click", toggleDropdown);

    item.addEventListener("keypress", function (e) {
      if (e.key !== "Enter") return;
      toggleDropdown.call(this, e);
    });
  });

  function setDropdownTransition(dropdown, enabled) {
    if (!dropdown) return;
    dropdown.classList.toggle("no-transition", !enabled);
  }

  function syncDropdownState(item, expanded, animate) {
    const link = item.querySelector("a");
    const dropdown = getDropdown(item);

    if (link) {
      link.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    item.classList.toggle("active", expanded);

    if (dropdown) {
      setDropdownTransition(dropdown, animate);
      dropdown.classList.toggle("show", expanded);

      if (!animate) {
        requestAnimationFrame(() => {
          dropdown.classList.remove("no-transition");
        });
      }
    }
  }

  function closeAllDropdowns(options = {}) {
    const animate = options.animate !== false;

    document
      .querySelectorAll("li.site-nav--has-dropdown")
      .forEach((item) => syncDropdownState(item, false, animate));
  }

  function toggleDropdown(e) {
    e.preventDefault();
    e.stopPropagation();

    const link = this.querySelector("a");
    const isExpanded = link.getAttribute("aria-expanded") === "true";
    const activeItem = document.querySelector("li.site-nav--has-dropdown.active");
    const switchingDropdown =
      activeItem && activeItem !== this && !isExpanded;

    closeAllDropdowns({ animate: !switchingDropdown });

    if (!isExpanded) {
      syncDropdownState(this, true, !switchingDropdown);
    }
  }

  // Store last focused trigger
  document.querySelectorAll("li.site-nav--has-dropdown > a").forEach((link) => {
    link.addEventListener("click", function () {
      lastFocusedMenuTrigger = this;
    });
  });

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".site-nav--has-dropdown")) {
      closeAllDropdowns();
    }
  });

  // Escape key handler
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    const activeItem = document.querySelector(
      "li.site-nav--has-dropdown.active",
    );
    if (!activeItem) return;

    closeAllDropdowns();

    if (lastFocusedMenuTrigger) {
      lastFocusedMenuTrigger.focus();
    }
  });
});
///// external links warning//
document.addEventListener("DOMContentLoaded", function () {
  // External links
  const currentHost = window.location.hostname.replace(/^www\./, "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";

  document.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;

    if (href.startsWith("http://") || href.startsWith("https://")) {
      const linkHost = new URL(href).hostname.replace(/^www\./, "");

      if (
        linkHost !== currentHost &&
        !link.classList.contains("external-link")
      ) {
        let label =
          link.getAttribute("aria-label") ||
          link.textContent.trim() ||
          link.querySelector("img")?.getAttribute("alt")?.trim() ||
          "External link";

        if (!label.includes(warningText.trim())) {
          label += warningText;
        }

        link.setAttribute("aria-label", label);
        link.setAttribute("title", label);

        if (!link.hasAttribute("target")) {
          link.setAttribute("target", "_blank");
        }

        link.classList.add("external-link");
      }
    }

    if (href.startsWith("mailto:") && !link.getAttribute("aria-label")) {
      const emailText = link.textContent.trim() || href.replace("mailto:", "");
      link.setAttribute("aria-label", `Email address ${emailText}`);
    }

    if (href.startsWith("tel:") && !link.getAttribute("aria-label")) {
      const phoneText = link.textContent.trim() || href.replace("tel:", "");
      link.setAttribute("aria-label", `Phone number ${phoneText}`);
    }
  });
});

// Br tags and mobile menu
document.addEventListener("DOMContentLoaded", function () {
  // Add aria-hidden to br and hr tags
  document.querySelectorAll("br, hr").forEach(function (el) {
    el.setAttribute("aria-hidden", "true");
  });

  // Close mobile drawer
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".js-drawer-open-nav.closebtns");

    if (closeBtn) {
      document
        .querySelectorAll(".drawer__close, .js-drawer-close")
        .forEach(function (el) {
          el.click();
        });
    }
  });

  const drawer = document.querySelector(".drawer");

  if (drawer) {
    const observer = new MutationObserver(function () {
      const isClosed = !drawer.classList.contains("is-open");

      if (isClosed) {
        const focusEl = document.querySelector(".closebtn");

        if (focusEl) {
          focusEl.focus();
        }
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});

// cart focus///
document.addEventListener("DOMContentLoaded", function () {
  let lastFocusedElement = null;
  document.querySelectorAll(".btn.btn--full.add-to-cart").forEach((btn) => {
    btn.addEventListener("click", function () {
      lastFocusedElement = this; // store Add to Cart button

      document.body.classList.add("cart-drawer-open");

      const drawer = document.querySelector(".cart-drawer");

      if (drawer) {
        setTimeout(() => {
          const firstFocusable = drawer.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );

          if (firstFocusable) firstFocusable.focus();
        }, 100);
      }
    });
  });
  document
    .querySelectorAll(".drawer__close-button.js-drawer-close")
    .forEach((btn) => {
      btn.addEventListener("click", function () {
        document.body.classList.remove("cart-drawer-open");

        setTimeout(() => {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }
        }, 100);
      });
    });
});

// this for size guide focus/////////
document.addEventListener("DOMContentLoaded", function () {
  const TRIGGER_SELECTOR = "tool-tip-trigger, .tool-tip-trigger";
  const TOOLTIP_SELECTOR = "tool-tip";
  const CLOSE_SELECTOR = "[data-tool-tip-close]";
  const OPEN_ATTR = "data-tool-tip-open";

  let lastTooltipTrigger = null;
  let wasOpen = false;


  document.addEventListener(
    "click",
    function (e) {
      const trigger = e.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;
      if (!trigger.hasAttribute("tabindex")) {
        trigger.setAttribute("tabindex", "0");
      }
      lastTooltipTrigger = trigger;
    },
    true,
  );

  function checkTooltipState() {
    const tooltip = document.querySelector(TOOLTIP_SELECTOR);
    if (!tooltip) return;
    const isOpen = tooltip.getAttribute(OPEN_ATTR) === "true";
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

  
    if (isOpen) {
      const closeBtn = tooltip.querySelector(CLOSE_SELECTOR);
      if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
    } else if (lastTooltipTrigger) {
      setTimeout(() => lastTooltipTrigger.focus(), 50);
    }
  }

  const observer = new MutationObserver(checkTooltipState);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: [OPEN_ATTR],
    subtree: true,
  });
});

// mobile menu///
document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest(".closebtn");
  if (closeBtn) {
    document
      .querySelectorAll(".drawer__close, .js-drawer-close")
      .forEach((el) => el.click());

    setTimeout(function () {
      const focusEl = document.querySelector(".closebtns");
      if (focusEl) focusEl.focus();
    }, 300);
  }
});

// search popup //////
document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.querySelector('.btn--close-search');
  const openBtn = document.querySelector('.small--hide.site-nav__link');

  if (closeBtn && openBtn) {
    closeBtn.addEventListener('click', function () {
      setTimeout(function () {
        openBtn.focus();
      }, 100);
    });
  }
});

// Removing the empty UL tag
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('ul.no-bullets.social-icons.footer__social').forEach(function (socialList) {
    if (socialList.children.length === 0 && socialList.textContent.trim() === '') {
      socialList.remove();
    }
  });
});